import { NavLink, Navigate, Outlet, Link } from "react-router-dom";
import { LayoutDashboard, Newspaper, Radio, Headphones, BookOpen, Users, MessageSquare, Mail, LogOut, ExternalLink, Images, Settings, Tags, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  ["/admin", "Tableau de bord", LayoutDashboard, "dashboard", true],
  ["/admin/articles", "Articles", Newspaper, "articles"],
  ["/admin/rubriques", "Rubriques", Tags, "categories"],
  ["/admin/ticker", "Flash infos", Radio, "ticker"],
  ["/admin/podcasts", "Podcasts", Headphones, "podcasts"],
  ["/admin/magazines", "Magazine", BookOpen, "magazines"],
  ["/admin/equipe", "Équipe", Users, "team"],
  ["/admin/commentaires", "Commentaires", MessageSquare, "comments"],
  ["/admin/abonnes", "Abonnés", Mail, "subscribers"],
  ["/admin/medias", "Médiathèque", Images, "media"],
  ["/admin/parametres", "Paramètres du site", Settings, "settings"],
  ["/admin/administrateurs", "Administrateurs", ShieldCheck, "users"],
];

export const AdminLayout = () => {
  const { user, logout } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-zinc-500">Chargement…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;

  return (
    <div className="min-h-screen flex bg-[#F3F4F6]">
      <aside className="w-64 bg-[#0F172A] text-zinc-300 flex flex-col shrink-0 sticky top-0 h-screen">
        <div className="p-5 border-b border-white/10">
          <div className="font-heading text-2xl font-black text-white">Chronique<span className="text-red-600">.cd</span></div>
          <div className="text-[10px] uppercase tracking-widest text-zinc-500 mt-1 font-bold">Administration</div>
        </div>
        <nav className="flex-1 py-4">
          {NAV.map(([to, label, Icon, id, end]) => (
            <NavLink key={to} to={to} end={end} data-testid={`admin-tab-${id}`} className={({ isActive }) => `flex items-center gap-3 px-5 py-3 text-sm font-medium transition-colors ${isActive ? "bg-red-600 text-white" : "hover:bg-white/5 hover:text-white"}`}>
              <Icon size={17} /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10 text-xs">
          <div className="text-white font-semibold truncate" data-testid="admin-user-email">{user.email}</div>
          <div className="flex gap-3 mt-3">
            <Link to="/" className="inline-flex items-center gap-1 hover:text-white"><ExternalLink size={12} /> Voir le site</Link>
            <button data-testid="admin-logout-btn" onClick={logout} className="inline-flex items-center gap-1 hover:text-red-400"><LogOut size={12} /> Déconnexion</button>
          </div>
        </div>
      </aside>
      <main className="flex-1 p-6 lg:p-10 min-w-0"><Outlet /></main>
    </div>
  );
};
